import { Component, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging';
@Component({
    selector: 'ef-job-audit-container',
    templateUrl: './job-audit-container.component.html',
    styleUrls: ['./job-audit-container.component.scss'],
    standalone: false
})
export class JobAuditContainerComponent implements OnInit {
    JobAuditModelDS: EntityCollectionService<fromDataServices.JobAudit.JobAuditModel>;
    JobAuditModel$: Observable<fromDataServices.JobAudit.JobAuditModel[]>;
    process$: Observable<fromShared.Process>;
    constructor(
        private log: LoggingService,
        public entityServices: EntityServices,
        private store: Store
    ) {
        this.log.verbose({ type: 'JobAuditContainerComponent::' });
        this.JobAuditModelDS =
            entityServices.getEntityCollectionService<fromDataServices.JobAudit.JobAuditModel>(
                fromDataServices.JobAudit.entityName
            );
    }
    ngOnInit(): void {
        this.JobAuditModelDS.clearCache();
        this.JobAuditModel$ = this.JobAuditModelDS.entities$.pipe(
            map(items => clone(items))
        );
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
    }
    onDateFiltersChanged($event: { startDate: Date; endDate: Date }) {
        this.log.verbose({
            type: 'JobAuditContainerComponent:onDateFiltersChanged',
            $event
        });
        this.JobAuditModelDS.clearCache();
        this.JobAuditModelDS.getWithQuery({
            EndDate: moment(moment($event.endDate).format('L'))
                .add(1, 'day')
                .format('L'),
            StartDate: moment($event.startDate).format('YYYY-MM-DD')
        });
    }
}
